import getSelectorsToHandle from './selectorsToHandle';
import getSelectorOnHandlers from './getSelectorOnHandlers';
import getDocumentOnHandlers from './getDocumentOnHandlers';
import handleDocumentOnEvent from './handleDocumentOnEvent';
import pushEvent from '../pushEvent';
import getEventObjects from './getEventObjects';

/**
 * Attach a handler.handler on the $attachPoint for the handler.event
 * Calls pushEvent with the returned eventObject from the handler
 *
 * @param {jQuery object} $attachPoint Where to attach the handlers
 * @param {object} handler A object with an event and handler property.
 * @example
 * hander = {
 * 	event: 'click', // string
 * 	handler: win.DDC.dataLayer.events.form.initiation // function
 * }
 */
const attach = ($attachPoint, { event, handler }, win) => {
	$attachPoint.on(event, async (...args) => {
		const eventObjects = await getEventObjects(handler, args);
		eventObjects.forEach((eventObject) => {
			pushEvent(win, eventObject);
		});
	});
};

const attachDocumentOnHandlers = (win, document, events) => {
	const pageBodyOnHandlers = getDocumentOnHandlers(win, events);

	Object.entries(pageBodyOnHandlers).forEach(([eventType, handlers]) => {
		handlers.forEach(({ selectorKey, handler }) => {
			const selector = getSelectorsToHandle(win)[selectorKey];
			const onArgs = selector ? [eventType, selector] : [eventType];

			$(document).on(...onArgs, (...args) => {
				handleDocumentOnEvent(win, args, selector, handler);
			});
		});
	});
};

const attachHandlers = (win, document) => {
	const { DDC } = win;
	const { events } = DDC.dataLayer;

	attachDocumentOnHandlers(win, document, events);

	getSelectorOnHandlers(events).forEach(({ event, selector, handler }) => {
		attach(
			$(getSelectorsToHandle(win)[selector]),
			{
				event,
				handler
			},
			win
		);
	});
};

export default attachHandlers;
